angular.module('fg').directive('fgFieldSignature', [
  '$timeout',
  function ($timeout) {
    //NOTE requires signature-pad depedency to be loaded by the site using this directive
    //     https://github.com/szimek/signature_pad

    return {
      replace: true,
      controllerAs: 'ctrl',
      controller: [
        '$scope',
        function ($scope) {
          var ctrl = this;
          ctrl.penColor = 'rgb(0, 0, 0)';
          ctrl.backgroundColor = 'rgb(255, 255, 255)';
        }
      ],
      templateUrl: 'angular-form-gen/field-templates/default/signature.ng.html',
      link: function (scope, iElem, $attrs, ctrls) {
        var signatureCanvasDefaultWidth = 500;
        var signatureCanvasDefaultHeight = 125;
        var signatureSaveBackgroundColor = 'rgb(249,249,249)';
        var resizeDebounceInMilliseconds = 100;
        var signatureFieldName = scope.field.schema.name;
        var signatureDataSavedByCurrentDirective;
        var resizeTimeoutPromise;
        var resizeObserver;

        var windowElement = angular.element(window);
        var signatureWrapper = iElem[0].querySelector('#signature-pad-wrapper');
        var canvasWrapper = signatureWrapper.querySelector('#canvas-wrapper');
        var signatureCanvas = signatureWrapper.querySelector(
          '#signature-pad-canvas'
        );
        var closeButton = angular.element(
          iElem[0].querySelector('#closeButton')
        );
        var tempCanvas = document.createElement('canvas');

        var signaturePad = new SignaturePad(signatureCanvas, {
          backgroundColor: ctrls.backgroundColor,
          penColor: ctrls.penColor,
          onEnd: onSignatureEnd
        });

        scope.$watch(
          function () {
            return getStoredSignatureData();
          },
          function (currentSignatureData) {
            updateSignatureData(currentSignatureData);
          }
        );

        $timeout(function () {
          resizeCanvas();
          updateSignatureData(getStoredSignatureData());

          closeButton.on('click', clearSignature);

          windowElement.on('resize', onWindowResize);

          if (window.ResizeObserver && canvasWrapper) {
            resizeObserver = new window.ResizeObserver(onWindowResize);
            resizeObserver.observe(canvasWrapper);
          }
        }, 500);

        scope.$on('$destroy', function () {
          closeButton.off('click', clearSignature);
          windowElement.off('resize', onWindowResize);

          if (resizeObserver) {
            resizeObserver.disconnect();
          }
        });

        function getCanvasWidth() {
          var canvasWidth = signatureCanvas.offsetWidth;

          if (!canvasWidth || canvasWidth <= 0) {
            canvasWidth = signatureCanvas.clientWidth;
          }

          if (!canvasWidth || canvasWidth <= 0) {
            canvasWidth = signatureCanvasDefaultWidth;
          }

          return canvasWidth;
        }

        function getCanvasHeight() {
          var canvasHeight = signatureCanvas.offsetHeight;

          if (!canvasHeight || canvasHeight <= 0) {
            return signatureCanvasDefaultHeight;
          }

          return canvasHeight;
        }

        function resizeCanvas() {
          var signatureData = signaturePad.toData();
          var devicePixelRatio = Math.max(window.devicePixelRatio || 1, 1);
          var canvasWidth = getCanvasWidth();
          var canvasHeight = getCanvasHeight();

          signatureCanvas.width = Math.round(canvasWidth * devicePixelRatio);
          signatureCanvas.height = Math.round(canvasHeight * devicePixelRatio);

          var canvasContext = signatureCanvas.getContext('2d');
          canvasContext.setTransform(1, 0, 0, 1, 0, 0);
          canvasContext.scale(devicePixelRatio, devicePixelRatio);

          tempCanvas.width = canvasWidth;
          tempCanvas.height = canvasHeight;

          signaturePad.clear();

          if (signatureData && signatureData.length > 0) {
            signaturePad.fromData(signatureData);
            return;
          }

          if (getStoredSignatureData()) {
            signaturePad.fromDataURL(getStoredSignatureData());
          }
        }

        function onWindowResize() {
          if (resizeTimeoutPromise) {
            $timeout.cancel(resizeTimeoutPromise);
          }

          resizeTimeoutPromise = $timeout(
            function () {
              resizeCanvas();
            },
            resizeDebounceInMilliseconds,
            false
          );
        }

        function onSignatureEnd() {
          saveSignature();
        }

        function clearSignature() {
          signaturePad.clear();
          signatureDataSavedByCurrentDirective = undefined;
          setStoredSignatureData(undefined);
        }

        function changeSignatureBgColor(bgColor) {
          var tempCanvasWidth = getCanvasWidth();
          var tempCanvasHeight = getCanvasHeight();
          var tempCanvasContext = tempCanvas.getContext('2d');

          tempCanvas.width = tempCanvasWidth;
          tempCanvas.height = tempCanvasHeight;

          tempCanvasContext.setTransform(1, 0, 0, 1, 0, 0);
          tempCanvasContext.clearRect(0, 0, tempCanvasWidth, tempCanvasHeight);
          tempCanvasContext.fillStyle = bgColor;
          tempCanvasContext.fillRect(0, 0, tempCanvasWidth, tempCanvasHeight);
          tempCanvasContext.drawImage(
            signatureCanvas,
            0,
            0,
            tempCanvasWidth,
            tempCanvasHeight
          );

          return tempCanvas.toDataURL();
        }

        function saveSignature() {
          var signatureDataWithGreyBackground = changeSignatureBgColor(
            signatureSaveBackgroundColor
          );

          signatureDataSavedByCurrentDirective =
            signatureDataWithGreyBackground;
          setStoredSignatureData(signatureDataWithGreyBackground);
        }

        function updateSignatureData(currentSignatureData) {
          if (!currentSignatureData) {
            return;
          }

          if (currentSignatureData === signatureDataSavedByCurrentDirective) {
            return;
          }

          resizeCanvas();
          signaturePad.fromDataURL(currentSignatureData);
        }

        function getStoredSignatureData() {
          return scope.form.data[signatureFieldName];
        }

        function setStoredSignatureData(signatureData) {
          scope.form.data[signatureFieldName] = signatureData;
        }
      }
    };
  }
]);
